// extracted by mini-css-extract-plugin
module.exports = {"root":"form_basic_root__31knO","alarm":"form_basic_alarm__2T8z3"};